import React from "react";
import { Container } from "react-bootstrap";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { Parallax } from "react-parallax";
// import BreadBG from "../../../public/breadBg.jpg";

const BreadCrumb = ({ title, pageTitle, breadBackground }) => {
    return (
        <div className="breads">
            <div className="inner">
                <Container>
                    <h1
                    // data-aos="fade-up"
                    // data-aos-duration="300"
                    // data-aos-delay="100"
                    >
                        {title}
                    </h1>
                    <ul>
                        <li
                        // data-aos="fade-up"
                        // data-aos-duration="300"
                        // data-aos-delay="200"
                        >
                            <Link href="/">
                                <a>
                                    <FormattedMessage id="home" />
                                </a>
                            </Link>
                        </li>
                        <li
                        // data-aos="fade-up"
                        // data-aos-duration="300"
                        // data-aos-delay="300"
                        >
                            {pageTitle}
                        </li>
                    </ul>
                </Container>
            </div>
        </div>
    );
};

export default BreadCrumb;
